module.exports = __webpack_public_path__ + "static/media/shish-kebab.4f7971cb.svg";